export const ThankyouAutomatedBundleStyles = {
  mainContainer: {
    width: '100%',
    minHeight: 'calc(100vh - 62px - 66px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '@media(max-width:600px)': {
      minHeight: 'calc(100vh - 44px - 66px)',
    },
  },

  subContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '48px 0px',
    width: 'fit-content',
    gap: '27px',
    '@media(max-width:600px)': {
      margin: '12px',
    },
    '@media(max-width:450px)': {
      margin: '12px 6px',
    },
  },

  welcomeText: {
    fontFamily: 'TTNORMSPROBOLD',
    fontWeight: '700',
    fontSize: '32px',
    lineHeight: '36px',
    letterSpacing: '0px',
    fontStyle: 'normal',
    textAlign: 'center',
  },

  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '27px',
    width: 'fit-content',
  },

  contentSubContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '27px',
    '@media(max-width:750px)': {
      flexDirection: 'column',
    },
  },

  accountContainer: {
    border: '1px solid #D0D0D0',
    borderRadius: '6px',
    padding: '24px',
    flex: '0 0 calc(50% - 13.5px)',
    '@media(max-width:750px)': {
      width: '100%',
    },
    '@media(max-width:450px)': {
      padding: '12px',
    },
  },

  accountSubContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'center',
    gap: '24px',
  },

  accountTypeContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'center',
  },

  accountTypeText1: {
    color: '#F58220',
    fontFamily: 'Arial',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: 'normal',
    letterSpacing: '0px',
    textAlign: 'start',
  },

  accountTypeText2: {
    fontFamily: 'Arial',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: 'normal',
    letterSpacing: '0px',
    textAlign: 'start',
  },

  accountNumContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'start',
    gap: '20px',
    '@media(max-width:450px)': {
      gap: '10px',
    },
  },

  accountImg: {
    height: '48px',
    width: '48px',
    '@media(max-width:600px)': {
      height: '54px',
      width: '54px',
    },
  },

  accountGrid: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'center',
    gap: '2px',
  },

  accountSubGrid1: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'start',
    gap: '2px',
  },

  accountSubGrid2: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'start',
    gap: '6px',
  },

  accountNumberText1: {
    fontFamily: 'Arial',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: '0px',
    textAlign: 'start',
  },

  accountNumberText2: {
    fontFamily: 'Arial',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: 'normal',
    letterSpacing: '0px',
    textAlign: 'start',
    '@media(max-width:600px)': {
      fontSize: '28px',
    },
  },

  contentSubContainerGrid: {
    border: '1px solid #D0D0D0',
    borderRadius: '6px',
    padding: '12px 24px',
    flex: '0 0 calc(50% - 13.5px)',
    alignContent: 'center',
    height: '85px',
    '@media(max-width:750px)': {
      width: '100%',
      height: 'auto',
    },
    '@media(max-width:450px)': {
      padding: '12px',
    },
  },

  contentSubContainerSubGrid: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'center',
    gap: '4px',
  },

  subGridText1: {
    color: '#444444',
    fontFamily: 'Arial',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: '0px',
    textAlign: 'start',
  },

  buttonContainer: {
    margin: '24',
    gap: '30px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  buttonContainerText: {
    fontFamily: 'Arial',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: '0px',
    textAlign: 'center',
  },

  bankingButton: {
    padding: '14px 50px',
    borderRadius: '56px',
  },

  bankingButtonText: {
    fontFamily: 'Arial !important',
    fontWeight: '700 !important',
    fontSize: '16px !important',
    lineHeight: '20px !important',
    textAlign: 'center !important',
    fontStyle: 'normal !important',
    textTransform: 'none !important',
    letterSpacing: '0px !important',
  },
};
